import * as React from 'react';

import Logo from 'assets/delegate/delegate-promo-small.svg?url';

import { Illustration } from './DelegateIllustration.styled';

const DelegateIllustration = () => (
    <Illustration>
        <img
            src={Logo}
            width="118"
            height="130"
            alt="Delegate ICE"
            loading="lazy"
            decoding="async"
        />
    </Illustration>
);

export default DelegateIllustration;
